export const productTypes = [
  { label: 'TQ', value: 'tq' },
  { label: 'SKT', value: 'skt' },
  { label: 'TE', value: 'te' },
  { label: 'JHARKHAND', value: 'jharkhand' },
]
